import * as types from './types';
import { HeaderAction } from './types';
import { HeaderState } from './state';

const initialHeaderState = {
    firstHeaderReload: true,
    isSticky: false
} as HeaderState;

export function headerReducer(headerState: HeaderState = initialHeaderState, action: HeaderAction): HeaderState {
    switch (action.type) {
        case types.RELOAD_HEADER:
            return {
                ...headerState,
                reload: true
            };

        case types.RELOAD_HEADER_SUCCESS:
            return {
                ...headerState,
                reload: false,
                firstHeaderReload: false
            };

        case types.SET_STICKY_MODE:
            return {
                ...headerState,
                isSticky: action.payload
            };

        default:
            return headerState;
    }
}
